import configure from './configure';

const store = configure();

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js